import { connect } from 'react-redux';
import { optionSelected } from '../../actions';
import SurveyQuestion from './component';

export const mapStateToProps = state => (
  {
    surveyQuestions: state.user.answers,
    displayErrors: state.survey.displayErrors,
  }
);

export default connect(mapStateToProps, { optionSelected })(SurveyQuestion);
